import { useCallback, useEffect, useRef } from 'react';

export default function useScrollTo() {
  const timeoutRef = useRef<number | null>(null);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return useCallback(
    (
      node: HTMLElement | null,
      topOffset: number = 0,
      focusElementSelector?: keyof HTMLElementTagNameMap,
    ) => {
      if (node) {
        const elementPosition = node.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.scrollY - topOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      }

      if (focusElementSelector) {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = window.setTimeout(() => {
          if (node) {
            const element = node.querySelector(focusElementSelector);
            if (element) {
              (element as HTMLElement).focus();
            }
          }
        }, 200);
      }
      // WTF ?
      // else {
      //   window.scrollTo({
      //     top: 0,
      //     behavior: 'smooth',
      //   });
      // }
    },
    [],
  );
}
